import merge from 'deepmerge'
import ZoneMessages from './messages/ZoneMessages'
import LocationMessages from './messages/LocationMessages'
import LocalityMessages from './messages/LocalityMessages'
import MapsPermissionMessages from './permissions/MapsPermissionMessages'

const messages = merge.all([
    ZoneMessages,
    LocationMessages,
    LocalityMessages,
    MapsPermissionMessages
])

export default messages;
